@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (!loading && surveyDashboard) {
  <div class="dashboard-card shadow-sm my-4 border-primary">
    <div class="card-header bg-white border-bottom p-4">
      <h4 class="dashboard-card-title text-primary-purple mb-1 d-flex align-items-center">
        <mat-icon class="dashboard-title-icon">fact_check</mat-icon>
        {{ 'modals.modal-survey-details.revisions-management' | translate }}
      </h4>
      <p class="text-muted mb-3">{{ 'components.surveys.survey-dashboard.survey-dashboard.component.description' | translate }}</p>

      <!-- Riepilogo Acceptable/Rejectable/To be revised, riusa .status-chip. -->
      @if (consensusSummaryChips.length > 0) {
        <div class="revision-summary-chips mb-3">
          @for (chip of consensusSummaryChips; track chip.key) {
            <span class="status-chip" [class]="chip.cssClass">
              {{ chip.labelKey | translate }} {{ chip.count }}
            </span>
          }
        </div>
      }

      <div class="decision-progress-header">
        <span class="font-weight-bold">{{ 'components.surveys.survey-dashboard.survey-dashboard.component.decisions-progress' | translate: { decided: decisionProgress.decided, total: decisionProgress.total } }}</span>
        @if (decisionProgress.decided < decisionProgress.total) {
          <span class="text-muted small">
            {{ 'components.surveys.survey-dashboard.survey-dashboard.component.decisions-remaining' | translate: { remaining: decisionProgress.total - decisionProgress.decided } }}
          </span>
        }
      </div>
      <mat-progress-bar mode="determinate" [value]="decisionProgressPercent" class="mt-2"></mat-progress-bar>
    </div>

    <div class="card-body p-4">
      @for (key of objectKeys(surveyDashboard); track key) {
        @if (surveyDashboard[key]?.questions.data?.length > 0) {
          <div class="revision-typology-section mb-4">
            <h6 class="text-primary-purple font-weight-bold mb-3 d-flex align-items-center">
              <mat-icon class="mr-2">topic</mat-icon>
              {{ "service.survey-service.question-typologies." + (key | lowercase) + ".title" | translate }}
            </h6>

            @if (key === 'CONSENSUS') {
              <!-- Grafico e filtri avanzati chiusi per default. -->
              <button type="button" class="revision-toggle-filters-btn mb-3" (click)="toggleFilters(key)">
                <mat-icon class="mr-2">insights</mat-icon>
                {{ (filtersExpanded[key] ? 'generic.hide-chart-and-filters' : 'generic.show-chart-and-filters') | translate }}
                <mat-icon class="ml-auto">{{ filtersExpanded[key] ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>

              @if (filtersExpanded[key]) {
              <div class="row g-4 mb-4">
                <div class="col-md-4">
                  <div echarts [options]="surveyCharts[key]" class="chart w-100"></div>
                </div>
                <div class="col-md-8 filters-block">
                <h6 class="text-primary-purple font-weight-bold mb-3 d-flex align-items-center">
                  <mat-icon class="mr-2">filter_list</mat-icon>
                  {{ 'generic.filters' | translate }}
                </h6>

                <div class="row g-4">
                  <div class="col-md-6">
                    <label class="form-label fw-bold d-block mb-2">
                      {{ "components.responses.consensus.agree" | translate }} (%)
                    </label>
                    <mat-slider [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="agree_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.agree[0]"
                        (ngModelChange)="updateFilter(key, 'agree', $event, 0)">
                    </mat-slider>
                    <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="agree_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.agree[1]"
                        (ngModelChange)="updateFilter(key, 'agree', $event, 1)">
                    </mat-slider>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold d-block mb-2">
                      {{ "generic.certainty-degree" | translate }} (%)
                    </label>
                    <mat-slider [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="certainty_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.certainty[0]"
                        (ngModelChange)="updateFilter(key, 'certainty', $event, 0)">
                    </mat-slider>
                    <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="certainty_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.certainty[1]"
                        (ngModelChange)="updateFilter(key, 'certainty', $event, 1)">
                    </mat-slider>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold d-block mb-2">
                      {{ "components.responses.consensus.disagree" | translate }} (%)
                    </label>
                    <mat-slider [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="disagree_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.disagree[0]"
                        (ngModelChange)="updateFilter(key, 'disagree', $event, 0)">
                    </mat-slider>
                    <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="disagree_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.disagree[1]"
                        (ngModelChange)="updateFilter(key, 'disagree', $event, 1)">
                    </mat-slider>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold d-block mb-2">
                      {{ "generic.contradiction-degree" | translate }} (%)
                    </label>
                    <mat-slider [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="contradiction_0_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.contradiction[0]"
                        (ngModelChange)="updateFilter(key, 'contradiction', $event, 0)">
                    </mat-slider>
                    <mat-slider class="slider-primary" [displayWith]="formatPercent" [discrete]="true">
                      <input matSliderThumb name="contradiction_1_{{key}}" min="0" max="100" step="1" [(ngModel)]="filters.contradiction[1]"
                        (ngModelChange)="updateFilter(key, 'contradiction', $event, 1)">
                    </mat-slider>
                  </div>

                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>{{ 'generic.section-filter' | translate }}</mat-label>
                      <mat-select name="filter_section" (selectionChange)="updateSectionFilter(key, $event.value)">
                        <mat-option value="">{{ "generic.all" | translate }}</mat-option>
                        @for (sec of keyQuestionsSections(key); track sec) {
                          <mat-option [value]="sec">
                            {{ sec }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>{{ 'generic.preliminary-round-assessment-filter' | translate }}</mat-label>
                      <mat-select name="filter_section" [multiple]="true"
                        (selectionChange)="updateStatusFilter(key, $event.value)">
                        @for (sec of keyQuestionsStatuses(key); track sec) {
                          <mat-option [value]="sec">
                            {{ "components.surveys.survey-dashboard.survey-dashboard.component." + (sec | lowercase) |
                            translate }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                </div>
              </div>
              }
            }

            <div class="revision-cards-container my-4">
              @for (element of getPaginatedQuestions(key); track element.id; let i = $index) {
                <div class="revision-card">
                  <div class="revision-card-header">
                    <div class="revision-card-statement">
                      {{ element.statement || element.question || 'N/A' }}
                    </div>
                    @if (key === 'CONSENSUS') {
                      <div class="revision-card-suggestion">
                        <span class="status-chip"
                          [class.status-chip-accepted]="element.status === 'ACCEPTED'"
                          [class.status-chip-rejected]="element.status === 'REJECTED'"
                          [class.status-chip-revision]="element.status !== 'ACCEPTED' && element.status !== 'REJECTED'">
                          {{ (element.status === 'REJECTED' || element.status === 'ACCEPTED'
                            ? "components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)
                            : "components.surveys.survey-dashboard.survey-dashboard.component.to_revision") | translate }}
                        </span>
                        <div class="revision-hint-text">{{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".title" | translate }}</div>
                        <button type="button" class="revision-see-details-btn" (click)="element.showSubtitle = !element.showSubtitle">
                          {{ (element.showSubtitle ? 'generic.hide-details' : 'generic.see-details') | translate }}
                          <mat-icon>{{ element.showSubtitle ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                      </div>
                    }
                  </div>

                  @if (key === 'CONSENSUS' && element.showSubtitle) {
                    <div class="revision-card-detail">
                      {{ ("components.surveys.survey-dashboard.survey-dashboard.component." + (element.status | lowercase)) + ".subtitle" | translate }}
                    </div>
                  }

                  <!-- Renderer generico per le metriche di qualunque
                       tipologia (dual-bar/stat/bar-list/stat-list) - vedi
                       getMetricBlocks() nel component. -->
                  @if (getMetricBlocks(key, element).length > 0) {
                    <div class="revision-metrics-grid">
                      @for (block of getMetricBlocks(key, element); track block.label) {
                        <div class="revision-metric">
                          <div class="revision-metric-label">{{ block.label }}</div>

                          @switch (block.kind) {
                            @case ('dual-bar') {
                              <div class="revision-bar-track">
                                <div class="revision-bar-fill revision-bar-fill-agree" [style.width.%]="block.leftPct"></div>
                                <div class="revision-bar-fill revision-bar-fill-disagree" [style.width.%]="block.rightPct"></div>
                              </div>
                              <div class="revision-bar-legend">
                                <span class="vote-label vote-label-agree">{{ block.leftLabel }}</span>
                                <span class="vote-label vote-label-disagree">{{ block.rightLabel }}</span>
                              </div>
                              @if (!element.required && element.abstained_count) {
                                <div class="revision-metric-caption">{{ "generic.abstained" | translate }}: {{ element.abstained_count }} ({{ element.abstained_perc | number:'1.0-2' }}%)</div>
                              }
                            }
                            @case ('stat') {
                              <div class="revision-metric-value">{{ block.value }}</div>
                              @if (block.caption) {
                                <div class="revision-metric-caption">{{ block.caption }}</div>
                              }
                            }
                            @case ('bar-list') {
                              <div class="revision-bar-list">
                                @for (bar of block.bars; track bar.label) {
                                  <div>
                                    <div class="revision-bar-legend mb-1">
                                      <span>{{ bar.label }}</span>
                                      <strong>{{ bar.valueLabel }}</strong>
                                    </div>
                                    <div class="revision-bar-track">
                                      <div class="revision-bar-fill revision-bar-fill-neutral" [style.width.%]="bar.pct"></div>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                            @case ('stat-list') {
                              <div class="revision-stat-list">
                                @for (item of block.items; track item.label) {
                                  <div class="revision-bar-legend">
                                    <span>{{ item.label }}</span>
                                    <strong>{{ item.value }}</strong>
                                  </div>
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                  }

                  <div class="revision-card-footer">
                    <div class="revision-cell-title">{{ "generic.final-decision" | translate }}</div>
                    @if (element.rewriting) {
                      <div class="rewriting-indicator">
                        <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                        <span class="rewriting-label">{{ "generic.rewriting" | translate }}</span>
                      </div>
                    } @else {
                      <app-survey-final-decision-selector
                        [element]="element"
                        [survey]="survey"
                        [typology]="key"
                        [statuses]="surveyService.questionFinalDecisionStatuses"
                        (decisionChange)="setFinalDecision($event.element, $event.decision)"
                        [appDisableRole]="['VIEWER']" [currentRole]="currentUserInTeam?.role"
                      />
                    }
                  </div>

                  <!-- Confronto revisione: testo originale affiancato al
                       testo rivisto (o agli statement dello split), per un
                       confronto diretto senza aprire il modal di
                       revisione/split. -->
                  @if (hasRevisionComparison(element)) {
                    <div class="revision-comparison">
                      <div class="revision-cell-title d-flex align-items-center">
                        <mat-icon class="mr-1">edit_note</mat-icon>
                        {{ "components.surveys.survey-dashboard.survey-dashboard.component.revision-comparison-title" | translate }}
                      </div>
                      <div class="revision-comparison-grid">
                        <div>
                          <div class="revision-comparison-label">{{ "components.surveys.survey-dashboard.survey-dashboard.component.original-label" | translate }}</div>
                          <div class="revision-comparison-box revision-comparison-original">
                            {{ element.statement || element.question }}
                          </div>
                        </div>
                        <div>
                          @if (getRevisedStatement(element); as revisedStatement) {
                            <div class="revision-comparison-label">{{ "components.surveys.survey-dashboard.survey-dashboard.component.revised-label" | translate }}</div>
                            <div class="revision-comparison-box revision-comparison-new">
                              {{ revisedStatement }}
                            </div>
                          } @else {
                            @for (split of getSplitStatements(element); track $index) {
                              <div class="revision-comparison-label">{{ "components.surveys.survey-dashboard.survey-dashboard.component.split-statement-label" | translate: { n: $index + 1 } }}</div>
                              <div class="revision-comparison-box revision-comparison-new mb-2">
                                {{ split.question }}
                              </div>
                            }
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            <mat-paginator
              [length]="getFilteredQuestions(key).length"
              [pageSize]="getPaginationState(key).pageSize"
              [pageIndex]="getPaginationState(key).pageIndex"
              [pageSizeOptions]="[5, 10, 20, 50]"
              showFirstLastButtons
              (page)="onPageChange(key, $event)">
            </mat-paginator>
          </div>
        }
      }
      @if (!survey?.is_revised) {
        <div class="row justify-content-center">
          <button class="btn-custom text-white my-3" matButton="filled" [disabled]="previewLoading"
            (click)="previewSurveyRevision()" *appHasRole="['OWNER', 'EDITOR']; role: currentUserInTeam?.role">
            @if (previewLoading) {
              <mat-spinner diameter="20" strokeWidth="3" class="button-spinner">
              </mat-spinner>
            }
            @if (!previewLoading) {
              <span>{{ 'modals.modal-survey-details.review-survey' | translate }}</span>
            }
          </button>
        </div>
      }
    </div>
  </div>
}
